<template>
  <rest-page :fetch-endpoint="fetchEndpoint" style="position: relative">
    <page-header-new :title="name" :breadcrumbs="breadcrumbs">
      <template slot="actions">
        <slot name="actions"></slot>
      </template>
    </page-header-new>

    <div class="frame-container">
      <iframe
        v-if="token"
        ref="metabase"
        :src="url"
        width="100%"
        height="200"
        frameborder="0"
        allowtransparency
      ></iframe>
    </div>
  </rest-page>
</template>

<script>
import RestPage from '@/common/components/rest/RestPage'
import { projectEndpoint } from '@/core/helpers'
import PageHeaderNew from '../../../common/components/page/PageHeaderNew'
import { projectRoute } from '../../../core/helpers'

export default {
  name: 'MetabaseDashboard',

  components: {
    PageHeaderNew,
    RestPage
  },

  methods: {
    applyFrameStyle() {
      setTimeout(() => {
        this.$refs['metabase'].addEventListener('load', () => {
          // let doc = this.$refs['metabase'].contentWindow.contentDocument
          // console.log(doc)
        })
      }, 0)
    }
  },

  computed: {
    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `metabase-dashboards/${this.$route.query.id}/embed-token`,
        handler: data => {
          this.name = data.name
          this.token = data.token
          this.applyFrameStyle()
        }
      })
    },

    url() {
      return (
        window.xp.metabaseUrl +
        '/embed/dashboard/' +
        encodeURIComponent(this.token) +
        '#bordered=false&titled=false'
      )
    },

    pageTitle() {
      return this.$t(this.$route.meta.title)
    },

    breadcrumbs() {
      return [
        {
          label: 'Intelligence'
        },
        {
          label: 'Dashboards',
          route: projectRoute({
            name: 'MetabaseDashboardList'
          })
        },
        {
          label: ''
        }
      ]
    }
  },

  data() {
    return {
      name: null,
      token: null
    }
  }
}
</script>

<style scoped>
.frame-container {
  position: absolute;
  top: 120px;
  left: 20px;
  right: 20px;
  bottom: 20px;
}

iframe {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #ffffff;
  border: 1px solid #dbdee7;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
</style>



// WEBPACK FOOTER //
// src/modules/metabase/pages/MetabaseDashboard.vue